<template>
  <ai-location-map
    :contact="contact"
    :address="address"
    :surroundings="surroundings"
    :hotel-name="hotelName" />
</template>

<script setup lang="ts">
import type {
  AddressFragment,
  ContactFragment,
  SurroundingsFragment,
} from '~~/domains/graphql';

interface HotelMapProps {
  contact: ContactFragment;
  address: AddressFragment;
  surroundings: SurroundingsFragment;
  hotelName?: string;
}

defineProps<HotelMapProps>();
</script>
